// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Color from "../Color/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_CommutativeRing from "../Data.CommutativeRing/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Interpolate from "../Data.Interpolate/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Vector2 from "../Data.Vector2/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Svg_Attributes from "../Halogen.Svg.Attributes/index.js";
import * as Halogen_Svg_Attributes_Path from "../Halogen.Svg.Attributes.Path/index.js";
import * as Halogen_Svg_Elements from "../Halogen.Svg.Elements/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Visonum_Cross_AppHTML from "../Visonum.Cross.AppHTML/index.js";
import * as Visonum_Cross_Data_Pixel from "../Visonum.Cross.Data.Pixel/index.js";
import * as Visonum_Cross_Style from "../Visonum.Cross.Style/index.js";
import * as Visonum_Cross_Styles from "../Visonum.Cross.Styles/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var styledNode_ = /* #__PURE__ */ Visonum_Cross_AppHTML.styledNode_(Visonum_Cross_Style.isStylesArrayString);
var interpStringFunction = /* #__PURE__ */ Data_Interpolate.interpStringFunction(Data_Interpolate.interpString);
var interpStringFunction1 = /* #__PURE__ */ Data_Interpolate.interpStringFunction(interpStringFunction);
var i = /* #__PURE__ */ Data_Interpolate.i(interpStringFunction1);
var i1 = /* #__PURE__ */ Data_Interpolate.i(/* #__PURE__ */ Data_Interpolate.interpStringFunction(interpStringFunction1));
var guard = /* #__PURE__ */ Data_Monoid.guard(Data_Monoid.monoidString);
var styledNode = /* #__PURE__ */ Visonum_Cross_AppHTML.styledNode(Visonum_Cross_Style.isStylesArrayString);
var mapWithIndex = /* #__PURE__ */ Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray);
var styledNode_1 = /* #__PURE__ */ Visonum_Cross_AppHTML.styledNode_(Visonum_Cross_Style.isStylesUnit);
var styledLeaf = /* #__PURE__ */ Visonum_Cross_AppHTML.styledLeaf(Visonum_Cross_Style.isStylesArrayString);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var max = /* #__PURE__ */ Data_Ord.max(Visonum_Cross_Data_Pixel.ordPixel);
var semiringVec = /* #__PURE__ */ Data_Vector2.semiringVec(Data_Semiring.semiringNumber);
var add2 = /* #__PURE__ */ Data_Semiring.add(semiringVec);
var mul1 = /* #__PURE__ */ Data_Semiring.mul(semiringVec);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Vector2.applicativeVec);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var sub2 = /* #__PURE__ */ Data_Ring.sub(/* #__PURE__ */ Data_Vector2.ringVec(Data_Ring.ringNumber));
var zero1 = /* #__PURE__ */ Data_Semiring.zero(semiringVec);
var styledLeaf_ = /* #__PURE__ */ Visonum_Cross_AppHTML.styledLeaf_(Visonum_Cross_Style.isStylesArrayString);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var i2 = /* #__PURE__ */ Data_Interpolate.i(interpStringFunction);
var Y = function (x) {
    return x;
};
var X = function (x) {
    return x;
};
var SmoothingFactor = function (x) {
    return x;
};
var ScrollUser = /* #__PURE__ */ (function () {
    function ScrollUser() {

    };
    ScrollUser.value = new ScrollUser();
    return ScrollUser;
})();
var ScrollAuto = /* #__PURE__ */ (function () {
    function ScrollAuto() {

    };
    ScrollAuto.value = new ScrollAuto();
    return ScrollAuto;
})();
var NewElem = /* #__PURE__ */ (function () {
    function NewElem(value0) {
        this.value0 = value0;
    };
    NewElem.create = function (value0) {
        return new NewElem(value0);
    };
    return NewElem;
})();
var showY = {
    show: function (v) {
        return "(Y " + (show(v) + ")");
    }
};
var showX = {
    show: function (v) {
        return "(X " + (show(v) + ")");
    }
};
var showMsg = {
    show: function (v) {
        if (v instanceof ScrollUser) {
            return "ScrollUser";
        };
        if (v instanceof ScrollAuto) {
            return "ScrollAuto";
        };
        if (v instanceof NewElem) {
            return "NewElem";
        };
        throw new Error("Failed pattern match at Visonum.Cross.Views.Chart (line 846, column 10 - line 849, column 27): " + [ v.constructor.name ]);
    }
};
var semiringY = Data_Semiring.semiringNumber;
var semiringX = Data_Semiring.semiringNumber;
var ringY = Data_Ring.ringNumber;
var ringX = Data_Ring.ringNumber;
var ordY = Data_Ord.ordNumber;
var ordX = Data_Ord.ordNumber;
var maximum = /* #__PURE__ */ Data_Foldable.maximum(ordX)(Data_Foldable.foldableArray);
var newtypeY_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeX_ = {
    Coercible0: function () {
        return undefined;
    }
};
var genericMsg_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return ScrollUser.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ScrollAuto.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new NewElem(x.value0.value0);
        };
        throw new Error("Failed pattern match at Visonum.Cross.Views.Chart (line 843, column 1 - line 843, column 30): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ScrollUser) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ScrollAuto) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof NewElem) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Visonum.Cross.Views.Chart (line 843, column 1 - line 843, column 30): " + [ x.constructor.name ]);
    }
};
var euclideanRingY = Data_EuclideanRing.euclideanRingNumber;
var euclideanRingX = Data_EuclideanRing.euclideanRingNumber;
var eqY = Data_Eq.eqNumber;
var eqX = Data_Eq.eqNumber;
var encodeJsonY = Data_Argonaut_Encode_Class.encodeJsonJNumber;
var encodeJsonX = Data_Argonaut_Encode_Class.encodeJsonJNumber;
var decodeJsonY = Data_Argonaut_Decode_Class.decodeJsonNumber;
var decodeJsonX = Data_Argonaut_Decode_Class.decodeJsonNumber;
var commutativeRingY = Data_CommutativeRing.commutativeRingNumber;
var commutativeRingX = Data_CommutativeRing.commutativeRingNumber;
var y2 = /* #__PURE__ */ Halogen_HTML_Properties.attr("y2");
var y1 = /* #__PURE__ */ Halogen_HTML_Properties.attr("y1");
var x2 = /* #__PURE__ */ Halogen_HTML_Properties.attr("x2");
var x1 = /* #__PURE__ */ Halogen_HTML_Properties.attr("x1");
var svgY = /* #__PURE__ */ Halogen_HTML_Properties.attr("y");
var svgX = /* #__PURE__ */ Halogen_HTML_Properties.attr("x");
var svgWidth = /* #__PURE__ */ Halogen_HTML_Properties.attr("width");
var svgHeight = /* #__PURE__ */ Halogen_HTML_Properties.attr("height");
var px$prime = function (v) {
    return show1(Data_Int.round(v));
};
var px = function (v) {
    return show(v) + "px";
};
var viewPseudoPercentFrame = function (v) {
    return function (children) {
        var el = {
            root: styledNode_(Halogen_Svg_Elements.svg)([ "height: 100%", i("width: ")(px(v.width)) ])
        };
        return el.root([ Halogen_HTML_Properties.attr("viewBox")(i1("0 0 ")(Visonum_Cross_Data_Pixel.toString(v.width))(" 100")), Halogen_HTML_Properties.attr("preserveAspectRatio")("none") ])(children);
    };
};
var viewXAxis = function (v) {
    return Visonum_Cross_AppHTML.withCtx(function (v1) {
        var el = {
            root: styledNode_(Halogen_HTML_Elements.div)([ "width: 100%", "height: 100%", "position: relative", guard(v1.debug)("outline: 1px solid red") ]),
            tick: function (v2) {
                return styledNode_(Halogen_HTML_Elements.div)([ "width: 30px", "height: 100%", "position: absolute", "display: flex", "flex-direction: column", "justify-content: space-between", "align-items: center", "transform: translateX(-50%)", i("left: ")(px(v.xToPx(v2.x))), guard(v1.debug)("outline: 1px solid green") ]);
            },
            tickLabel: function (ix) {
                return styledNode(Halogen_HTML_Elements.div)(function (ctx) {
                    return [ "overflow: hidden", "font-size: 10px", guard(v1.debug)("outline: 1px solid blue"), (function () {
                        if (v.inheritFonts) {
                            return "";
                        };
                        return Visonum_Cross_Styles.fontInter;
                    })(), Visonum_Cross_Styles.color(ctx.theme.colors.gray500), (function () {
                        var $125 = ix === 0;
                        if ($125) {
                            return "transform: translate(3px, 0px)";
                        };
                        return "";
                    })() ];
                });
            },
            tickLine: styledNode(Halogen_HTML_Elements.div)(function (ctx) {
                return [ "width: 1px", i("background-color: ")(Color.toHexString(ctx.theme.colors.gray500)), "flex: 0 0 5px", "margin-top: 5px" ];
            })
        };
        return el.root([  ])(mapWithIndex(function (ix) {
            return function (x) {
                return el.tick({
                    x: x
                })([  ])([ el.tickLine([  ])([  ]), el.tickLabel(ix)([  ])([ Visonum_Cross_AppHTML.text(Data_Maybe.maybe("")(function (v2) {
                    return v2(x);
                })(v.print)) ]) ]);
            };
        })(v.ticks));
    });
};
var pct$prime = function (v) {
    return show1(Data_Int.round(v));
};
var pct = function (v) {
    return show(v) + "%";
};
var viewXLines = function (v) {
    var el = {
        root: styledNode_1(Halogen_Svg_Elements.g)(Data_Unit.unit),
        rect: styledLeaf(Halogen_Svg_Elements.rect)(function (ctx) {
            return [ "stroke: none", i("fill: ")(Color.toHexString(ctx.theme.colors.gray700)) ];
        })
    };
    return el.root([  ])(map(function (x) {
        return el.rect([ svgX(px$prime(v.xToPx(x))), svgY("0%"), svgWidth(px$prime(1.0)), svgHeight(pct(100.0)) ]);
    })(v.lines));
};
var viewYAxis = function (v) {
    return Visonum_Cross_AppHTML.withCtx(function (v1) {
        var el = {
            root: styledNode_(Halogen_HTML_Elements.div)([ "position: relative", "height: 100%", guard(v1.debug)("outline: 1px solid red") ]),
            tick: function (v2) {
                return styledNode_(Halogen_HTML_Elements.div)([ "width: 100%", "height: 10px", "position: absolute", "display: flex", "flex-direction: row", "align-items: center", "transform: translateY(-50%)", "gap: 5px", i("top: ")(pct(v.yToPct(v2.y))), guard(v1.debug)("outline: 1px solid green") ]);
            },
            tickLabel: styledNode(Halogen_HTML_Elements.div)(function (ctx) {
                return [ "flex: 1 1 auto", "overflow: hidden", "font-size: 10px", "text-align: right", guard(v1.debug)("outline: 1px solid blue"), (function () {
                    if (v.inheritFonts) {
                        return "";
                    };
                    return Visonum_Cross_Styles.fontInter;
                })(), Visonum_Cross_Styles.color(ctx.theme.colors.gray500) ];
            }),
            tickLine: styledNode(Halogen_HTML_Elements.div)(function (ctx) {
                return [ "height: 1px", "margin-top: 1px", i("background-color: ")(Color.toHexString(ctx.theme.colors.gray500)), "flex: 0 0 5px", "margin-right: 3px" ];
            })
        };
        return el.root([  ])(map(function (y) {
            return el.tick({
                y: y
            })([  ])([ el.tickLabel([  ])([ Visonum_Cross_AppHTML.text(Data_Maybe.maybe("")(function (v2) {
                return v2(y);
            })(v.print)) ]), el.tickLine([  ])([  ]) ]);
        })(v.ticks));
    });
};
var viewYLines = function (v) {
    var el = {
        root: styledNode_1(Halogen_Svg_Elements.g)(Data_Unit.unit),
        rect: styledLeaf(Halogen_Svg_Elements.rect)(function (ctx) {
            return [ "stroke: none", i("fill: ")(Color.toHexString(ctx.theme.colors.gray700)) ];
        }),
        bookedSpeedText: styledNode(Halogen_Svg_Elements.text)(function (ctx) {
            return [ i("fill: ")(Color.toHexString(ctx.theme.colors.secondary400)), "font-size: 13px", Visonum_Cross_Styles.fontVodafoneBold ];
        }),
        bookedSpeedLine: styledLeaf(Halogen_Svg_Elements.line)(function (ctx) {
            return [ i("stroke: ")(Color.toHexString(ctx.theme.colors.secondary400)), "fill: none" ];
        })
    };
    return el.root([  ])(append1(map(function (y) {
        return el.rect([ svgX(px$prime(0.0)), svgY(pct(v.yToPct(y))), svgWidth(px(max(10000.0)(v.xToPx(v.maxX)))), svgHeight(px$prime(1.0)) ]);
    })(v.lines))(append1((function () {
        if (v.horizontalLine instanceof Data_Maybe.Just) {
            return [ el.bookedSpeedText([ svgY(pct(v.yToPct(v.horizontalLine.value0 + 2000000.0))), svgX(px$prime(570.0)) ])([ Visonum_Cross_AppHTML.text("Dein Tarif") ]) ];
        };
        if (v.horizontalLine instanceof Data_Maybe.Nothing) {
            return [  ];
        };
        throw new Error("Failed pattern match at Visonum.Cross.Views.Chart (line 524, column 13 - line 534, column 28): " + [ v.horizontalLine.constructor.name ]);
    })())((function () {
        if (v.horizontalLine instanceof Data_Maybe.Just) {
            return [ el.bookedSpeedLine([ x1("0"), y1(pct(v.yToPct(v.horizontalLine.value0))), x2("700.0"), y2(pct(v.yToPct(v.horizontalLine.value0))), Halogen_Svg_Attributes.strokeDashArray("10 5") ]) ];
        };
        if (v.horizontalLine instanceof Data_Maybe.Nothing) {
            return [  ];
        };
        throw new Error("Failed pattern match at Visonum.Cross.Views.Chart (line 536, column 13 - line 546, column 28): " + [ v.horizontalLine.constructor.name ]);
    })())));
};
var mkYtoPct = function (v) {
    return function (v1) {
        var factor = v1 / v.yMax;
        var factorMirrored = 1.0 - factor;
        return factorMirrored * 100.0;
    };
};
var mkXtoPx = function (v) {
    return function (v1) {
        var rel = v1 - v.xMin;
        return rel * v.pixelsPerX;
    };
};
var mkSmoothPath = function (v) {
    return function (v1) {
        if (v1.length === 0) {
            return [ Halogen_Svg_Attributes_Path.m(Halogen_Svg_Attributes_Path.Abs.value)(0.0)(0.0) ];
        };
        var mkPathPoint = function (v2) {
            return function (v3) {
                if (v2 === 0) {
                    return Halogen_Svg_Attributes_Path.m(Halogen_Svg_Attributes_Path.Abs.value)(v3.value0)(v3.value1);
                };
                var pStart = Data_Maybe.fromMaybe(new Data_Vector2.Vec(0, 0))(Data_Array.index(v1)(v2 - 1 | 0));
                var pPrev = Data_Maybe.fromMaybe(pStart)(Data_Array.index(v1)(v2 - 2 | 0));
                var pNext = Data_Maybe.fromMaybe(v3)(Data_Array.index(v1)(v2 + 1 | 0));
                var v4 = add2(pStart)(mul1(pure(coerce(v)))(sub2(v3)(pPrev)));
                var v5 = add2(v3)(mul1(pure(coerce(v)))(sub2(pStart)(pNext)));
                return Halogen_Svg_Attributes_Path.c(Halogen_Svg_Attributes_Path.Abs.value)(v4.value0)(v4.value1)(v5.value0)(v5.value1)(v3.value0)(v3.value1);
            };
        };
        var isLast = function (index) {
            return index === (Data_Array.length(v1) - 1 | 0);
        };
        return mapWithIndex(mkPathPoint)(v1);
    };
};
var mkSmoothPathClosedAtBottom = function (smoothing) {
    return function (points) {
        var v = Data_Maybe.fromMaybe(zero1)(Data_Array.last(points));
        var v1 = Data_Maybe.fromMaybe(zero1)(Data_Array.head(points));
        return append1(mkSmoothPath(smoothing)(points))([ Halogen_Svg_Attributes_Path.l(Halogen_Svg_Attributes_Path.Abs.value)(v.value0)(v.value1), Halogen_Svg_Attributes_Path.l(Halogen_Svg_Attributes_Path.Abs.value)(v.value0)(100.0), Halogen_Svg_Attributes_Path.l(Halogen_Svg_Attributes_Path.Abs.value)(v1.value0)(100.0), Halogen_Svg_Attributes_Path.l(Halogen_Svg_Attributes_Path.Abs.value)(v1.value0)(v1.value1), Halogen_Svg_Attributes_Path.z ]);
    };
};
var viewFilledPart = function (v) {
    var scoped = Visonum_Cross_AppHTML.scopedHtml(function (v1) {
        return Halogen_Svg_Elements.element("linearGradient")([ Halogen_HTML_Properties.id(v1.unique), x1("0"), x2("0"), y1("0"), y2("1") ])([ Halogen_Svg_Elements.element("stop")([ Halogen_HTML_Properties.attr("style")(i1("stop-color: ")(Color.toHexString(v.styles.lineColor))("; stop-opacity: 0.8")), Halogen_HTML_Properties.attr("offset")("0%") ])([  ]), Halogen_Svg_Elements.element("stop")([ Halogen_HTML_Properties.attr("style")(i1("stop-color: ")(Color.toHexString(v.styles.lineColor))("; stop-opacity: 0.2")), Halogen_HTML_Properties.attr("offset")("100%") ])([  ]) ]);
    });
    var points = map(function (v1) {
        return new Data_Vector2.Vec(coerce(v.xToPx(v1.value0)), coerce(v.yToPct(v1.value1)));
    })(v.dataPoints);
    var pathCommands = mkSmoothPathClosedAtBottom(v.smoothingFactor)(points);
    var el = {
        path: styledLeaf_(Halogen_Svg_Elements.path)([ "stroke: none", i1("fill: url(#")(scoped.unique)(")") ]),
        defs: styledNode_1(Halogen_Svg_Elements.defs)(Data_Unit.unit)
    };
    return viewPseudoPercentFrame({
        width: v.xToPx(v.maxX)
    })([ el.path([ Halogen_Svg_Attributes.d(pathCommands) ]), Visonum_Cross_AppHTML.fromHTML(scoped.html) ]);
};
var viewExtraDataLines = function (v) {
    var el = {
        root: styledNode_(Halogen_Svg_Elements.svg)([ "height: 100%", i("width: ")(px(v.xToPx(v.maxX))) ]),
        path: styledLeaf_(Halogen_Svg_Elements.path)([ "stroke-width: 1px", "fill: none", i("stroke: ")(Color.toHexString(v.styles.lineColor)) ])
    };
    return el.root([ Halogen_HTML_Properties.attr("viewBox")(i1("0 0 ")(Visonum_Cross_Data_Pixel.toString(v.xToPx(v.maxX)))(" 100")), Halogen_HTML_Properties.attr("preserveAspectRatio")("none") ])(map(function (dataPoints) {
        var points = map(function (v1) {
            return new Data_Vector2.Vec(coerce(v.xToPx(v1.value0)), coerce(v.yToPct(v1.value1)));
        })(dataPoints);
        var pathCommands = mkSmoothPath(v.smoothingFactor)(points);
        return el.path([ Halogen_Svg_Attributes.d(pathCommands), Halogen_HTML_Properties.attr("vector-effect")("non-scaling-stroke") ]);
    })(v.extraData));
};
var cy = /* #__PURE__ */ Halogen_HTML_Properties.attr("cy");
var cx = /* #__PURE__ */ Halogen_HTML_Properties.attr("cx");
var viewDots = function (v) {
    var el = {
        dot: styledLeaf_(Halogen_Svg_Elements.circle)([ "stroke-width: 1px", "stroke: white", "fill: grey" ]),
        group: styledNode_1(Halogen_Svg_Elements.g)(Data_Unit.unit)
    };
    return el.group([  ])(map(function (v1) {
        return el.dot([ cx(px$prime(v.xToPx(v1.value0))), cy(pct(v.yToPct(v1.value1))), Halogen_Svg_Attributes.r(Visonum_Cross_Data_Pixel.toNumber(3.0)) ]);
    })(v.dataPoints));
};
var viewMarkers = function (v) {
    var el = {
        root: styledNode_1(Halogen_Svg_Elements.g)(Data_Unit.unit),
        marker: styledNode_1(Halogen_Svg_Elements.g)(Data_Unit.unit),
        markerDot: styledLeaf_(Halogen_Svg_Elements.circle)([ "stroke-width: 1px", "stroke: white", "fill: grey" ]),
        markerImg: styledLeaf_(Halogen_Svg_Elements.image)([ "transform: translate(-13px, -35px)" ])
    };
    return el.root([  ])(map(function (v1) {
        return el.marker([  ])([ el.markerDot([ cx(px$prime(v.xToPx(v1.position.value0))), cy(pct(v.yToPct(v1.position.value1))), Halogen_Svg_Attributes.r(Visonum_Cross_Data_Pixel.toNumber(5.0)) ]), el.markerImg([ Halogen_HTML_Properties.attr("href")(unwrap(v1.icon)), svgX(px$prime(v.xToPx(v1.position.value0))), svgY(pct(v.yToPct(v1.position.value1))), Halogen_Svg_Attributes.width(Visonum_Cross_Data_Pixel.toNumber(26.0)) ]) ]);
    })(v.markers));
};
var view = function (v) {
    return Visonum_Cross_AppHTML.withCtx(function (v1) {
        var yToPct = mkYtoPct({
            yMax: v.yAxis.max
        });
        var xToPx = mkXtoPx({
            xMin: v.xAxis.min,
            pixelsPerX: v.xAxis.pixelsPerX
        });
        var maxX = Data_Maybe.fromMaybe(0.0)(maximum(map(Data_Tuple.fst)(v.data_.main)));
        var heightTicksX = (function () {
            if (v.xAxis.show) {
                return 30.0;
            };
            return 0.0;
        })();
        var el = {
            root: styledNode_(Halogen_HTML_Elements.div)([ "width: 100%", "height: 100%", "color: white", "position: relative", "display: grid", i("grid-template-rows: minmax(0, 1fr) ")(px(heightTicksX)), guard(v1.debug)("outline: 1px solid orange") ]),
            staticPanel: styledNode_(Halogen_HTML_Elements.div)([ "overflow: auto", "overflow-y: clip", "padding-bottom: 5px", "grid-row: 1 / 3", guard(v1.debug)("outline: 1px solid green"), "cursor: grab" ]),
            dynamicPanel: styledNode_(Halogen_HTML_Elements.div)([ "height: 100%", "display: grid", "margin-left: 40px", i1("width: ")(px$prime(xToPx(maxX)))("px"), i("grid-template-rows: minmax(0, 1fr) ")(px(heightTicksX)), guard(v1.debug)("outline: 1px solid blue"), "pointer-events: none" ]),
            chart: styledNode_(Halogen_Svg_Elements.svg)([ "grid-row: 1 / 2", "width: 100%", "height: 100%", "overflow: visible", guard(v1.debug)("outline: 1px solid yellow"), "pointer-events: none" ]),
            xTicks: styledNode_(Halogen_HTML_Elements.div)([ "grid-row: 2 / 3", guard(v1.debug)("outline: 1px solid purple"), "overflow: hidden" ]),
            yTicks: styledNode_(Halogen_HTML_Elements.div)([ "position: absolute", "top: 0", "left: 0px", "width: 40px", i2("height: calc(100% - 35px)"), guard(v1.debug)("outline: 1px solid purple") ]),
            shadow: styledNode(Halogen_HTML_Elements.div)(function (ctx1) {
                if (v.styles.haveShadow) {
                    return [ "position: absolute", "top: 0", "left: 0px", "width: 40px", "height: 100%", i1("background-image: linear-gradient(to right, ")(Color.toHexString(ctx1.theme.colors.gray900))(", rgba(0,0,0,0))"), "pointer-events: none" ];
                };
                return [ "" ];
            }),
            yAxisLabel: styledNode_(Halogen_HTML_Elements.div)([ "color: black", "font-size: 13px", "transform: rotate(-90deg)", "transform-origin: center center", "position: absolute", "top: 50%", "left: -50px", "text-align: center", Visonum_Cross_Styles.fontVodafoneBold ])
        };
        return el.root([  ])([ (function () {
            if (v.styles.yAxisLabelText instanceof Data_Maybe.Nothing) {
                return Visonum_Cross_AppHTML.none;
            };
            if (v.styles.yAxisLabelText instanceof Data_Maybe.Just) {
                return el.yAxisLabel([  ])([ Visonum_Cross_AppHTML.text(v.styles.yAxisLabelText.value0) ]);
            };
            throw new Error("Failed pattern match at Visonum.Cross.Views.Chart (line 203, column 9 - line 205, column 64): " + [ v.styles.yAxisLabelText.constructor.name ]);
        })(), el.staticPanel([ Halogen_HTML_Properties.classes([ "scroll-by-drag", "hide-scrollbars" ]), Halogen_HTML_Events.onScroll(function (event) {
            var $228 = $foreign.isUserScroll({
                threshold: 40.0
            }, event);
            if ($228) {
                return ScrollUser.value;
            };
            return ScrollAuto.value;
        }), Halogen_HTML_Properties.id("chart_static_panel") ])([ el.shadow([  ])([  ]), el.yTicks([  ])([ viewYAxis({
            ticks: v.yAxis.ticks,
            yToPct: yToPct,
            print: v.yAxis.print,
            inheritFonts: v.styles.inheritFonts
        }) ]), el.dynamicPanel([  ])([ el.chart([  ])([ viewYLines({
            lines: v.yAxis.lines,
            xToPx: xToPx,
            yToPct: yToPct,
            maxX: maxX,
            horizontalLine: v.horizontalLine
        }), viewXLines({
            lines: v.xAxis.lines,
            xToPx: xToPx
        }), viewFilledPart({
            dataPoints: v.data_.main,
            smoothingFactor: v.smoothingFactor,
            xToPx: xToPx,
            yToPct: yToPct,
            styles: v.styles,
            maxX: maxX
        }), (function () {
            if (v1.debug) {
                return viewDots({
                    dataPoints: v.data_.main,
                    xToPx: xToPx,
                    yToPct: yToPct,
                    styles: v.styles
                });
            };
            return Visonum_Cross_AppHTML.none;
        })(), viewExtraDataLines({
            extraData: v.data_.extra,
            xToPx: xToPx,
            yToPct: yToPct,
            maxX: maxX,
            smoothingFactor: v.smoothingFactor,
            styles: v.styles
        }), viewMarkers({
            markers: v.markers,
            xToPx: xToPx,
            yToPct: yToPct
        }) ]), el.xTicks([  ])([ viewXAxis({
            ticks: v.xAxis.ticks,
            xToPx: xToPx,
            print: v.xAxis.print,
            inheritFonts: v.styles.inheritFonts
        }) ]) ]) ]) ]);
    });
};
var clipPath = /* #__PURE__ */ Halogen_HTML_Elements.element("clipPath");
export {
    X,
    Y,
    ScrollUser,
    ScrollAuto,
    NewElem,
    SmoothingFactor,
    view,
    showX,
    showY,
    eqX,
    ordX,
    semiringX,
    ringX,
    euclideanRingX,
    commutativeRingX,
    encodeJsonX,
    decodeJsonX,
    newtypeX_,
    eqY,
    ordY,
    semiringY,
    ringY,
    euclideanRingY,
    commutativeRingY,
    encodeJsonY,
    decodeJsonY,
    newtypeY_,
    genericMsg_,
    showMsg
};
